export type ReferenceGenerationErrorReason = 'already_running' | 'no_sessions' | 'unavailable' | 'unknown';

export class ReferenceGenerationError extends Error {
    constructor(
        public readonly reason: ReferenceGenerationErrorReason,
        message = 'Error while generating the reference',
    ) {
        super(message);
        this.name = 'ReferenceGenerationError';
    }
}
